import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Filter, Main } from 'Containers';
import { Button, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, reset } from 'redux-form';
import { Checkbox } from 'semantic-ui-react';
import { NotificationMessage } from 'Components';
import { errorToast } from 'Common/ToastHelper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { resetForm } from 'State/forms/actions';
import { MANAGE_PURCHASE_ORDER_FORM_NAME } from 'Common/FormEnum';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import { getVendorForCurrentSite } from 'State/filters/actions';
import { actions } from '../../state/actions';
import ManagePurchaseOrderComponent from '../../components/managePurchaseOrderList/ManagePurchaseOrder';
import { ManagePurchaseOrderEnum, FilterEnum } from 'Common/FieldEnum';
import {
  StatusOptionEnum,
  OrdertypeEnum,
  ManagePurchaseOrderStatusEnum,
  ReceiptTypeEnum,
  PrintTypeEnum,
  TypeDataEnum,
} from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';

import 'Styles/pages/inventory/managePurchaseOrder/index.less';
import {
  PrintSortTypeEnum,
  GenericEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { basicURL } from './../../helper/index';

class ManagePurchaseOrderContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCloseConfirm: false,
      showCloseModel: false,
      selectedOrder: null,
      isContainWO: false,
      checkPrintType: false,
      showDeleteModel: false,
      showDeleteConfirm: false,
      selectedOrders: [],
      activeIndexes: [0, 1],
      columns: [
        {
          Header: currentRows => {
            const { selectedOrders } = this.state;
            const dataObjs = currentRows.data;
            let filteredData = [];
            let checkAllIds = [];
            _.forEach(dataObjs, obj => {
              const id = obj[ManagePurchaseOrderEnum.Receipt]
                ? obj[ManagePurchaseOrderEnum.Receipt]
                : obj._original[ManagePurchaseOrderEnum.Receipt];
              if (selectedOrders.indexOf(id) === -1) {
                filteredData.push(id);
              } else {
                checkAllIds.push(id);
              }
            });
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    dataObjs.length > 0 &&
                    checkAllIds.length === dataObjs.length
                  }
                  onChange={(e, { checked }) => {
                    e.stopPropagation();
                    if (checked) {
                      this.setState({
                        selectedOrders: [
                          ...this.state.selectedOrders,
                          ...filteredData,
                        ],
                      });
                    } else {
                      const copySelected = [...this.state.selectedOrders];
                      _.forEach(dataObjs, obj => {
                        const id = obj[ManagePurchaseOrderEnum.Receipt]
                          ? obj[ManagePurchaseOrderEnum.Receipt]
                          : obj._original[ManagePurchaseOrderEnum.Receipt];
                        const index = copySelected.indexOf(id);
                        if (index !== -1) {
                          copySelected.splice(index, 1);
                        }
                      });
                      this.setState({ selectedOrders: copySelected });
                    }
                  }}
                />
              </div>
            );
          },
          accessor: ManagePurchaseOrderEnum.Allowed,
          sortable: false,
          show: true,
          visibility: false,
          Cell: ({ original }) => {
            const { selectedOrders } = this.state;
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    selectedOrders.indexOf(
                      original[ManagePurchaseOrderEnum.Receipt]
                    ) !== -1
                  }
                  onChange={(e, { checked }) => {
                    this.checkCurrentRow(original, checked);
                  }}
                />
              </div>
            );
          },
        },
        {
          Header: 'Receipt#',
          accessor: ManagePurchaseOrderEnum.Receipt,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Order Number',
          accessor: ManagePurchaseOrderEnum.OrderNumber,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Order Tag',
          accessor: ManagePurchaseOrderEnum.OrderTypeName,
          id: ManagePurchaseOrderEnum.OrderTypeName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Type',
          accessor: ManagePurchaseOrderEnum.Type,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'PO/WO/KO Number',
          accessor: ManagePurchaseOrderEnum.PoWoNumber,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Id',
          accessor: ManagePurchaseOrderEnum.SiteId,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Name',
          accessor: ManagePurchaseOrderEnum.SiteName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Distributor',
          accessor: ManagePurchaseOrderEnum.VendorName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Order Date',
          accessor: ManagePurchaseOrderEnum.OrderDT,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Delivery/Receipt Date',
          accessor: ManagePurchaseOrderEnum.DeliveryDT,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Status',
          accessor: ManagePurchaseOrderEnum.Status,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Invoice',
          accessor: ManagePurchaseOrderEnum.Invoice,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Handling Fee PO',
          accessor: ManagePurchaseOrderEnum.HandlingFeePO,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'GL Updated',
          accessor: ManagePurchaseOrderEnum.GlUpdated,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'PO/WO/KO Comment',
          accessor: ManagePurchaseOrderEnum.POWOComments,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Receipt Comment',
          accessor: ManagePurchaseOrderEnum.ReceiptComments,
          ...ReactTableWrapperColumnProperties,
        },
        {
          width: 50,
          sortable: false,
          Cell: gridProps => {
            return GridContextMenu({
              gridProps,
              options: this.getMenuOptions(gridProps),
            });
          },
        },
      ],
    };
    this.reactTable = React.createRef();
  }

  componentDidMount() {
    const {
      beginDT,
      endDT,
      initialValues,
      site,
      vendorId,
      viewStatusOptionsValue,
      viewReceiptOptionsValue,
    } = this.props;
    const statusFilter =
      viewStatusOptionsValue === ManagePurchaseOrderEnum.All
        ? ''
        : viewStatusOptionsValue === ManagePurchaseOrderEnum.Open
          ? StatusOptionEnum.OPEN
          : StatusOptionEnum.CLOSED;
    const filtersOptions = {
      Vendor: vendorId ? vendorId : initialValues[FilterEnum.VendorId],
      Site: site ? site : initialValues[FilterEnum.SiteId],
      DateFrom: beginDT
        ? moment(beginDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .subtract(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      DateTo: endDT
        ? moment(endDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .add(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      Status: viewStatusOptionsValue ? statusFilter : StatusOptionEnum.OPEN,
      Show: viewReceiptOptionsValue
        ? viewReceiptOptionsValue
        : ReceiptTypeEnum.ALL,
    };
    this.props.getPurchaseOrderData(filtersOptions);
    this.props.getVendorForCurrentSite();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.purchaseOrderListData.Errors !==
        this.props.purchaseOrderListData.Errors &&
      this.props.purchaseOrderListData.Errors &&
      this.props.purchaseOrderListData.Errors.length
    ) {
      NotificationMessage(this.props.purchaseOrderListData);
    }

    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'deleteError')
    ) {
      this.props.clearPurchaseOrderError();
    }
  }

  handleVendorChange = (e, newVal, preVal) => {
    const {
      beginDT,
      endDT,
      site,
      viewStatusOptionsValue,
      viewReceiptOptionsValue,
    } = this.props;
    if (newVal !== preVal) {
      this.getFilterData(
        beginDT,
        endDT,
        site,
        newVal,
        viewStatusOptionsValue,
        viewReceiptOptionsValue
      );
      this.setState({ selectedOrders: [] });
    }
  };
  handleSiteChange = (newVal, preVal) => {
    const {
      beginDT,
      endDT,
      vendorId,
      viewStatusOptionsValue,
      viewReceiptOptionsValue,
    } = this.props;
    if (newVal !== preVal) {
      this.getFilterData(
        beginDT,
        endDT,
        newVal,
        vendorId,
        viewStatusOptionsValue,
        viewReceiptOptionsValue
      );
      this.setState({ selectedOrders: [] });
    }
  };

  handleCloseDialog = result => {
    if (result) {
      const {
        beginDT,
        endDT,
        site,
        vendorId,
        viewStatusOptionsValue,
        viewReceiptOptionsValue,
      } = this.props;
      const selectedOrders = this.getFilteredSelectedPurchaseOrder();
      const orderList = {
        ReceiptIds: selectedOrders,
      };

      if (!selectedOrders.length) {
        orderList.ReceiptIds[0] = this.state.selectedOrder[
          ManagePurchaseOrderEnum.Receipt
        ];
      }
      this.props.closePurchaseOrder(orderList).then(result => {
        NotificationMessage(result.response.data);
        this.getFilterData(
          beginDT,
          endDT,
          site,
          vendorId,
          viewStatusOptionsValue,
          viewReceiptOptionsValue
        );
      });
    }

    this.setState({ showCloseModel: false });
  };

  closeOrderConfirm = () => {
    this.setState({
      showCloseConfirm: !this.state.showCloseConfirm,
    });
  };

  showCloseModelForm = row => {
    const selectedOrders = this.getFilteredSelectedPurchaseOrder();
    const selectedOrder = selectedOrders.length ? 0 : row;
    const selectedStatus = _.filter(
      this.props.purchaseOrderListData.GetData,
      item =>
        selectedOrders.indexOf(item[ManagePurchaseOrderEnum.Receipt]) !== -1 &&
        item[ManagePurchaseOrderEnum.Status] ===
          ManagePurchaseOrderStatusEnum.CLOSED
    );

    if (selectedStatus.length) {
      this.setState({
        showCloseConfirm: !this.state.showCloseConfirm,
      });
      return;
    }

    this.setState({
      selectedOrder,
      showCloseModel: !this.state.showCloseModel,
    });
  };

  setShowStatusOption = value => {
    const {
      beginDT,
      endDT,
      site,
      vendorId,
      viewReceiptOptionsValue,
    } = this.props;
    this.getFilterData(
      beginDT,
      endDT,
      site,
      vendorId,
      value,
      viewReceiptOptionsValue
    );
    this.setState({ selectedOrders: [] });
  };

  setShowReceiptOption = value => {
    const {
      beginDT,
      endDT,
      site,
      vendorId,
      viewStatusOptionsValue,
    } = this.props;
    this.getFilterData(
      beginDT,
      endDT,
      site,
      vendorId,
      viewStatusOptionsValue,
      value
    );
    this.setState({ selectedOrders: [] });
  };

  completeReset = () => {
    this.props.resetForm(MANAGE_PURCHASE_ORDER_FORM_NAME);
  };

  clearFilters = () => {
    this.props.dispatch(reset(MANAGE_PURCHASE_ORDER_FORM_NAME));
    const { initialValues } = this.props;
    const {
      BeginDT,
      EndDT,
      SiteId,
      VendorId,
      ViewStatusOptions,
      ViewReceiptOptions,
    } = initialValues;
    this.props.setFromDateMax(moment().add(1, 'month'));
    this.props.setToDateMin(moment().subtract(1, 'month'));

    this.getFilterData(
      BeginDT,
      EndDT,
      SiteId,
      VendorId,
      ViewStatusOptions,
      ViewReceiptOptions
    );
    this.setState({ selectedOrders: [] });
    this.completeReset();
  };

  getFilterData = (
    beginDT,
    endDT,
    siteId,
    vendorId,
    viewStatusOptionsValue,
    viewReceiptOptionsValue
  ) => {
    const statusFilter =
      viewStatusOptionsValue === ManagePurchaseOrderEnum.All
        ? ''
        : viewStatusOptionsValue === ManagePurchaseOrderEnum.Open
          ? StatusOptionEnum.OPEN
          : StatusOptionEnum.CLOSED;

    if (beginDT && endDT) {
      const filtersOptions = {
        Vendor: vendorId,
        Site: siteId,
        DateFrom: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
        DateTo: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        Status: statusFilter,
        Show: viewReceiptOptionsValue,
      };
      this.props.getPurchaseOrderData(filtersOptions);
    }
  };
  onChangeOfFromDT = (e, beginDate) => {
    this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate) => {
    this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate, prevDate) => {
    const {
      endDT,
      site,
      vendorId,
      viewStatusOptionsValue,
      viewReceiptOptionsValue,
    } = this.props;
    if (beginDate !== prevDate) {
      this.props.setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
      this.getFilterData(
        beginDate,
        endDT,
        site,
        vendorId,
        viewStatusOptionsValue,
        viewReceiptOptionsValue
      );
      this.setState({ selectedOrders: [] });
    }
  };

  selectToDate = (e, endDate, prevDate) => {
    const {
      beginDT,
      site,
      vendorId,
      viewStatusOptionsValue,
      viewReceiptOptionsValue,
    } = this.props;
    if (endDate !== prevDate) {
      this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
      this.getFilterData(
        beginDT,
        endDate,
        site,
        vendorId,
        viewStatusOptionsValue,
        viewReceiptOptionsValue
      );
      this.setState({ selectedOrders: [] });
    }
  };

  downloadEleFile = row => {
    const selectedOrders = this.getFilteredSelectedPurchaseOrder();
    const filteredOrderList = _.filter(
      this.props.purchaseOrderListData.GetData,
      item =>
        selectedOrders.indexOf(item[ManagePurchaseOrderEnum.Receipt]) !== -1
    );

    const orderList = _.filter(filteredOrderList, x => {
      return (
        x.Type === TypeDataEnum.KO ||
        x.Type === TypeDataEnum.WO ||
        !x.OrderNumber
      );
    });

    if (orderList.length) {
      this.setState({
        isContainWO: true,
      });
      return;
    }

    const receiptIds = _.filter(filteredOrderList, x => {
      return x.Type === TypeDataEnum.PO;
    }).map(x => x[ManagePurchaseOrderEnum.Receipt]);

    if (!filteredOrderList.length) {
      receiptIds[0] = row[ManagePurchaseOrderEnum.Receipt];
    }

    this.props.getEleFileData(receiptIds);
  };

  handleEleFileDownload = () => {
    this.setState({
      isContainWO: false,
    });
  };

  onEditClick = row => {
    let orderType =
      row.Type === TypeDataEnum.PO
        ? OrdertypeEnum.PO
        : row.Type === TypeDataEnum.WO
          ? OrdertypeEnum.WO
          : row.Type === TypeDataEnum.KO
            ? OrdertypeEnum.KO
            : OrdertypeEnum.MAN;
    this.props.history.push(
      `${basicURL}/purchase/powo/${row.POWONumber}/${
        row.SiteId
      }/${orderType}/${false}`
    );
  };

  onEditReceiptClick = row => {
    let orderType =
      row.Type === TypeDataEnum.PO
        ? OrdertypeEnum.PO
        : row.Type === TypeDataEnum.WO
          ? OrdertypeEnum.WO
          : row.Type === TypeDataEnum.KO
            ? OrdertypeEnum.KO
            : OrdertypeEnum.MAN;
    this.props.history.push(
      `${basicURL}/purchase/receipt/1/${row.ReceiptId}/${orderType}`
    );
  };
  onDeleteClick = row => {
    const selectedOrders = this.getFilteredSelectedPurchaseOrder();
    const selectedOrder = selectedOrders.length ? 0 : row;
    const selectedStatus = _.filter(
      this.props.purchaseOrderListData.GetData,
      item =>
        selectedOrders.indexOf(item[ManagePurchaseOrderEnum.Receipt]) !== -1 &&
        item[ManagePurchaseOrderEnum.Status] ===
          ManagePurchaseOrderStatusEnum.CLOSED
    );

    if (selectedStatus.length) {
      this.setState({
        showDeleteConfirm: !this.state.showDeleteConfirm,
      });
      return;
    }

    this.setState({
      selectedOrder,
      showDeleteModel: !this.state.showDeleteModel,
    });
  };
  closeDeleteOrderConfirm = () => {
    this.setState({
      showDeleteConfirm: !this.state.showDeleteConfirm,
    });
  };
  handleDeleteDialog = result => {
    if (result) {
      const {
        beginDT,
        endDT,
        site,
        vendorId,
        viewStatusOptionsValue,
        viewReceiptOptionsValue,
      } = this.props;
      const orderList = this.getFilteredSelectedPurchaseOrder();
      if (!orderList.length) {
        orderList[0] = this.state.selectedOrder[
          ManagePurchaseOrderEnum.Receipt
        ];
      }

      this.props.managePOWOReceiptDelete(orderList).then(result => {
        NotificationMessage(result.response.data);
        this.getFilterData(
          beginDT,
          endDT,
          site,
          vendorId,
          viewStatusOptionsValue,
          viewReceiptOptionsValue
        );
      });
    }

    this.setState({ showDeleteModel: false });
  };
  getMenuOptions = gridProps => {
    const { purchaseOrderListData } = this.props;
    const { row } = gridProps;
    const selectedOrders = this.getFilteredSelectedPurchaseOrder();

    let menuOptions = [
      {
        icon: 'pencil',
        text:
          row && row.Type === TypeDataEnum.WO
            ? 'View/Edit WO'
            : row && row.Type === TypeDataEnum.PO
              ? 'View/Edit PO'
              : 'View/Edit KO',
        handler: this.onEditClick,
        disabledWhen: row => selectedOrders.length > 1 || !row.OrderNumber,
      },
      {
        icon: 'pencil',
        text: 'View/Edit Receipt',
        handler: this.onEditReceiptClick,
      },
      {
        icon: 'close',
        text: 'Close',
        handler: this.showCloseModelForm,
        disabledWhen: row =>
          row.Status === ManagePurchaseOrderStatusEnum.CLOSED,
      },
      {
        icon: 'download',
        text: 'Download Electronic File',
        handler: this.downloadEleFile,
        disabledWhen: row =>
          row.Type === TypeDataEnum.WO ||
          row.Type === TypeDataEnum.KO ||
          !row.OrderNumber ||
          (row.Type === TypeDataEnum.PO &&
            row.Status === ManagePurchaseOrderStatusEnum.CLOSED),
      },
      {
        icon: 'delete',
        text: 'Delete',
        className: 'danger',
        handler: this.onDeleteClick,
        disabledWhen: row =>
          row.Status === ManagePurchaseOrderStatusEnum.CLOSED,
      },
    ];
    if (selectedOrders.length > 1) {
      menuOptions = [
        {
          icon: 'close',
          text: 'Close',
          handler: this.showCloseModelForm,
          disabledWhen: row =>
            row.Status === ManagePurchaseOrderStatusEnum.CLOSED,
        },
        {
          icon: 'download',
          text: 'Download Electronic File',
          handler: this.downloadEleFile,
        },
        {
          icon: 'delete',
          text: 'Delete All',
          className: 'danger',
          handler: this.onDeleteClick,
          disabledWhen: row =>
            purchaseOrderListData.GetData &&
            Array.isArray(purchaseOrderListData.GetData) &&
            purchaseOrderListData.GetData.length &&
            purchaseOrderListData.GetData.some(item => {
              return item.Status === ManagePurchaseOrderStatusEnum.CLOSED;
            }),
        },
      ];
    }
    return menuOptions;
  };

  printOrderReceipt = () => {
    const { purchaseOrderListData } = this.props;
    const selectedOrders = this.getFilteredSelectedPurchaseOrder();

    const filteredOrderList = _.filter(
      purchaseOrderListData.GetData,
      item =>
        selectedOrders.indexOf(item[ManagePurchaseOrderEnum.Receipt]) !== -1
    );
    const dataObjs =
      this.reactTable && this.reactTable.current
        ? this.reactTable.current.getResolvedState()
        : { sortedData: purchaseOrderListData.GetData };
    if (
      filteredOrderList &&
      !filteredOrderList.length &&
      dataObjs.sortedData.length
    ) {
      filteredOrderList[0] = dataObjs.sortedData[0];
    }
    const printType = this.props.printOptionsValue;
    const isContainOrder = _.filter(
      filteredOrderList,
      x => x[ManagePurchaseOrderEnum.PoWoNumber]
    );
    if (filteredOrderList.length) {
      if (!isContainOrder.length && printType !== PrintTypeEnum.Receipt) {
        this.setState({
          checkPrintType: true,
        });
      } else {
        this.onClickPrint(filteredOrderList, printType);
      }
    }
  };

  handlePrintClick = () => {
    this.setState({
      checkPrintType: false,
    });
  };

  onClickPrint = (filteredOrderList, printType) => {
    let sortType = this.props.sortOptionValue;
    sortType =
      sortType === ManagePurchaseOrderEnum.ItemCode
        ? PrintSortTypeEnum.ItemCode
        : PrintSortTypeEnum.ItemDescription;
    if (printType === PrintTypeEnum.Receipt) {
      const receiptIds = _.map(filteredOrderList, item =>
        item[ManagePurchaseOrderEnum.Receipt].toString()
      );
      if (!receiptIds.length) {
        receiptIds.push(
          this.props.purchaseOrderListData.GetData[0][
            ManagePurchaseOrderEnum.Receipt
          ].toString()
        );
      }
      const requestData = {
        ReceiptIds: receiptIds,
        SortType: sortType,
      };
      this.props.getPurchaseOrderReceiptPrint(requestData);
    }
    if (printType === PrintTypeEnum.Order) {
      const poIds = _.filter(filteredOrderList, x => {
        return x.Type === TypeDataEnum.PO;
      }).map(x => x.POWONumber);

      const woIds = _.filter(filteredOrderList, x => {
        return x.Type === TypeDataEnum.WO;
      }).map(x => x.POWONumber + ',' + x.SiteId);

      const koIds = _.filter(filteredOrderList, x => {
        return x.Type === TypeDataEnum.KO;
      }).map(x => x.POWONumber + ',' + x.SiteId);

      const requestData = {
        poId: poIds,
        woId: woIds,
        koId: koIds,
        sortType: sortType,
      };

      this.props.getPurchaseOrderPrintData(requestData);
    }
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  checkCurrentRow = (original, checked) => {
    let value = [...this.state.selectedOrders];
    checked
      ? value.indexOf(original[ManagePurchaseOrderEnum.Receipt]) === -1 &&
        value.push(original[ManagePurchaseOrderEnum.Receipt])
      : value.indexOf(original[ManagePurchaseOrderEnum.Receipt]) !== -1 &&
        value.splice(
          value.indexOf(original[ManagePurchaseOrderEnum.Receipt]),
          1
        );

    this.setState({ selectedOrders: value });
  };
  getFilteredSelectedPurchaseOrder = () => {
    const { purchaseOrderListData } = this.props;
    const { selectedOrders } = this.state;
    const checkedUsageOrders = [];
    const dataObjs =
      this.reactTable && this.reactTable.current
        ? this.reactTable.current.getResolvedState()
        : { sortedData: purchaseOrderListData.GetData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[ManagePurchaseOrderEnum.Receipt]
        ? obj[ManagePurchaseOrderEnum.Receipt]
        : obj._original[ManagePurchaseOrderEnum.Receipt];
      if (selectedOrders.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };
  onCreateReceiptInventoryClick = () => {
    this.props.history.push(
      `${basicURL}/purchase/receipt/0/0/${OrdertypeEnum.MAN}`
    );
  };

  render() {
    const {
      loading,
      closing,
      deletePOWOReceiptLoading,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      fromDateMax,
      toDateMin,
    } = this.props;
    return (
      <Fragment>
        <Filter title={'Purchase Order/ Receive Inventory '}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={6} />
              <Grid.Column width={6} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New Receipt"
                  type={'button'}
                  onClick={this.onCreateReceiptInventoryClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main>
          <ManagePurchaseOrderComponent
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={fromDateMax}
            onChangeOfToDT={this.onChangeOfToDT}
            toDateMin={toDateMin}
            columns={this.state.columns}
            reactTable={this.reactTable}
            showCloseModel={this.state.showCloseModel}
            handleCloseDialog={this.handleCloseDialog}
            showCloseConfirm={this.state.showCloseConfirm}
            closeOrderConfirm={this.closeOrderConfirm}
            purchaseOrderListData={this.props.purchaseOrderListData}
            assignItemsVendorData={this.props.assignItemsVendorData}
            handleVendorChange={this.handleVendorChange}
            setShowStatusOption={this.setShowStatusOption}
            setShowReceiptOption={this.setShowReceiptOption}
            clearFilters={this.clearFilters}
            loading={loading}
            selectedOrder={this.state.selectedOrder}
            closing={closing}
            printOrderReceipt={this.printOrderReceipt}
            printLoading={this.props.printLoading}
            isContainWO={this.state.isContainWO}
            handleEleFileDownload={this.handleEleFileDownload}
            eleFileDownloadMsg={this.props.eleFileDownloadMsg}
            handleEleFileMsgDialog={
              this.props.emptyEleFileDownloadSuccessMessage
            }
            checkPrintType={this.state.checkPrintType}
            handlePrintClick={this.handlePrintClick}
            showDeleteConfirm={this.state.showDeleteConfirm}
            closeDeleteOrderConfirm={this.closeDeleteOrderConfirm}
            showDeleteModel={this.state.showDeleteModel}
            handleDeleteDialog={this.handleDeleteDialog}
            deletePOWOReceiptLoading={deletePOWOReceiptLoading}
            gridPreferenceLoading={gridPreferenceLoading}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            activeIndexes={this.state.activeIndexes}
            handleClick={this.handleClick}
            handleSiteChange={this.handleSiteChange}
          />
        </Main>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values[ManagePurchaseOrderEnum.BeginDT]) {
    errors[ManagePurchaseOrderEnum.BeginDT] = 'Please select Begin Date';
  }
  if (!values[ManagePurchaseOrderEnum.EndDT]) {
    errors[ManagePurchaseOrderEnum.EndDT] = 'Please select End Date';
  }

  return errors;
};

const mapStateToProps = state => {
  const {
    PurchaseOrderState: { managePurchaseOrder },
    CommonState: { filters, gridPreference },
  } = state;
  const {
    purchaseOrderListData,
    loading,
    closing,
    printLoading,
    printError,
    eleFileData,
    eleFileDownloadMsg,
    deletePOWOReceiptLoading,
    deleteError,
    fromDateMax,
    toDateMin,
  } = managePurchaseOrder;
  const selector = formValueSelector(MANAGE_PURCHASE_ORDER_FORM_NAME);

  return {
    purchaseOrderListData: purchaseOrderListData,
    beginDT: selector(state, ManagePurchaseOrderEnum.BeginDT),
    endDT: selector(state, ManagePurchaseOrderEnum.EndDT),
    loading: loading,
    closing: closing,
    eleFileData: eleFileData,
    initialValues: {
      [ManagePurchaseOrderEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [ManagePurchaseOrderEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [FilterEnum.VendorId]: 0,
      [FilterEnum.SiteId]: GenericEnum.ZeroString,
      [ManagePurchaseOrderEnum.ViewStatusOptions]: ManagePurchaseOrderEnum.Open,
      [ManagePurchaseOrderEnum.ViewReceiptOptions]: ReceiptTypeEnum.ALL,
      [ManagePurchaseOrderEnum.SortOptions]: ManagePurchaseOrderEnum.ItemCode,
      [ManagePurchaseOrderEnum.PrintOptions]: PrintTypeEnum.Order,
    },
    site: selector(state, ManagePurchaseOrderEnum.SiteId),
    vendorId: selector(state, FilterEnum.VendorId),
    printOptionsValue: selector(state, ManagePurchaseOrderEnum.PrintOptions),
    viewStatusOptionsValue: selector(
      state,
      ManagePurchaseOrderEnum.ViewStatusOptions
    ),
    viewReceiptOptionsValue: selector(
      state,
      ManagePurchaseOrderEnum.ViewReceiptOptions
    ),
    sortOptions: selector(state, ManagePurchaseOrderEnum.SortOptions),
    assignItemsVendorData: filters.vendorData,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    printLoading: printLoading,
    printError: printError,
    eleFileDownloadMsg,
    deletePOWOReceiptLoading,
    deleteError,
    fromDateMax,
    toDateMin,
  };
};

const mapDispatchToProps = {
  getVendorForCurrentSite,
  resetForm,
  ...actions,
};
ManagePurchaseOrderContainer = reduxForm({
  validate,
  destroyOnUnmount: false,
  form: MANAGE_PURCHASE_ORDER_FORM_NAME,
})(ManagePurchaseOrderContainer);

export const ManagePurchaseOrder = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagePurchaseOrderContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/containers/managePurchaseOrderList/ManagePurchaseOrder.js